import { useState } from "react";
import { DemonstrativoExtratoBancarioTab } from "../demonstrativo-extrato-bancario.types";

export function useDemonstrativoExtratoBancario() {
  const [activeTab, setActiveTab] = useState<DemonstrativoExtratoBancarioTab>("Todos");

  return {
    activeTab,
    setActiveTab
  }
}